/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


  var getMonth = function(idx) {

      var objDate = new Date();
      objDate.setDate(1);
      objDate.setMonth(idx-1);

      var locale = "pt-br",
          month = objDate.toLocaleString(locale, { month: "long" });

      return month;
    }
    
  let xhr = new XMLHttpRequest();

  xhr.open('GET', 'https://get.geojs.io/v1/ip/geo.json');

  xhr.onreadystatechange = () => {
      if(xhr.readyState == 4) {
          if(xhr.status == 200) {
            let response=JSON.parse(xhr.responseText);
            document.getElementById("free-ship-reg").innerHTML=response.city + " e ";
            
          }
      }
  };

  xhr.send();

    var numberOfDaysToAdd = 20;
    var numberOfDaysToAdd2 = 40;
    
  
	var someDate = new Date();
  	someDate.setDate(someDate.getDate() + numberOfDaysToAdd); 
    var dd = someDate.getDate();
    var mm = someDate.getMonth() + 1;
    var y = someDate.getFullYear();
    var someFormattedDate = dd + '/'+ mm + '/'+ y;


    var someDate2 = new Date();
    someDate2.setDate(someDate2.getDate() + numberOfDaysToAdd2); 
    var dd2 = someDate2.getDate();
    var mm2 = someDate2.getMonth() + 1;
    var y2 = someDate2.getFullYear();

    var someFormattedDate2 = dd2 + '/'+ mm2 + '/'+ y2;


    document.getElementById("d-ship-1").innerHTML= dd+ " de " + getMonth(mm);
    document.getElementById("d-ship-2").innerHTML= dd2 + " de " + getMonth(mm2);


